import { useMemo } from "react";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useHasActiveContent } from "CrossFeatureComponents/MemberToolbar/stateHooks";
import { LOGIN_CONTENT_PADDING } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import FnrFade from "UI/FnrFade";
import FnrSlides from "UI/FnrSlides";

import { Divider } from "../shared";

import ContactForm from "./ContactForm";
import ContactMenu from "./ContactMenu";
import Login from "./Login";
import MessageSent from "./MessageSent";
import { UserMenu } from "./UserMenu/UserMenu";

const activeContentSwitchConfig = [
  { key: contentKeys.nothing, value: () => null },
  { key: contentKeys.user, value: UserMenu },
  { key: contentKeys.login, value: Login },
  { key: contentKeys.contact, value: ContactMenu },
  { key: contentKeys.form, value: ContactForm, keepInDOM: true },
  { key: contentKeys.messageSent, value: MessageSent },
];

const ActiveContent = () => {
  const { activeContentKey } = useMemberToobarContext();

  const isUserContent = useMemo(
    () => activeContentKey !== "nothing" && activeContentKey !== "login",
    [activeContentKey]
  );

  const hasActiveContent = useHasActiveContent();

  return (
    <>
      <FnrSlides
        sizeSpring={hasActiveContent} // only spring when going from nothing to something
        activeKey={activeContentKey}
        axis={
          hasActiveContent /* TODO: set up ref for y motion when animating out? */
            ? "x"
            : "y"
        }
        fullWidth
        components={activeContentSwitchConfig}
      />
      <FnrFade show={isUserContent}>
        <Divider marginX={12} />
      </FnrFade>
    </>
  );
};

export { ActiveContent, LOGIN_CONTENT_PADDING };
